import React from 'react';
import { Button, Empty, List } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import ConversationListItem from './ConversationListItem';

const ConversationList = ({
    ovrs,
    selectedOvr,
    onSelectOvr,
    onCreateNew,
    getStatusBadge
}) => {
    return (
        <div className="w-full md:w-[30%] h-[100dvh] md:h-screen bg-white md:border-l rounded border-gray-200 flex flex-col min-w-0">
            {/* Sidebar Header */}
            <div className="p-3 sm:p-4 border-b border-gray-200 rounded-lg bg-[#298d9f] shrink-0">
                <div className="flex items-center justify-between gap-2">
                    <h2 className="text-base sm:text-lg font-semibold text-white m-0 truncate">
                        OVR Conversations
                    </h2>
                    <Button
                        type="text"
                        icon={<PlusOutlined className="text-white" />}
                        onClick={onCreateNew}
                        className="text-white hover:bg-[#236d7c] shrink-0"
                    />
                </div>
            </div>

            {/* Conversations List */}
            <div className="flex-1 min-h-0 overflow-y-auto">
                {ovrs.length === 0 ? (
                    <Empty
                        description="No conversations"
                        className="mt-8"
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                    >
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={onCreateNew}
                            className="bg-[#298d9f]"
                        >
                            Create First OVR
                        </Button>
                    </Empty>
                ) : (
                    <List
                        dataSource={ovrs}
                        renderItem={(item) => (
                            <ConversationListItem
                                key={item.id}
                                ovr={item}
                                isActive={selectedOvr?.id === item.id}
                                getStatusBadge={getStatusBadge}
                                onClick={() => onSelectOvr(item)}
                            />
                        )}
                    />
                )}
            </div>
        </div>
    );
};

export default ConversationList;